/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import Actions from './Actions/index'
import CompactViewNotes from './CompactViewNotes/index'
import CreateFieldAction from './CreateFieldAction/index'
import DataVaxiomTxCardFieldDefinitionsList from 'DesignSystem/Data/DataVaxiom/DataVaxiomTxCardFieldDefinitions/DataVaxiomTxCardFieldDefinitionsList/index'
import DefaultView from './DefaultView/index'
import React from 'react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Settings/Content/TreatmentCard/Content/Content"
  
}) {
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
let dtSpaceXl = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xl'
        })
let selectedLocationIdValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'location_id',
})
  return (<React.Fragment
>
<DefaultView
  viewPath={`${viewPath}/DefaultView`}
/>
<CompactViewNotes
  viewPath={`${viewPath}/CompactViewNotes`}
/>
<Actions
  viewPath={`${viewPath}/Actions`}
/>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-Z1Yf8zk': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h2"
 text="Treatment Fields"
/>
<CreateFieldAction
  viewPath={`${viewPath}/CreateFieldAction`}
/>
</div>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--pb-2-Z1Yf8zk': typeof dtSpaceXl === 'number' ? `${dtSpaceXl}px` : dtSpaceXl}}
 className={`views-block ${styles.Vertical}`}
>
<DataVaxiomTxCardFieldDefinitionsList
  viewPath={`${viewPath}/DataVaxiomTxCardFieldDefinitionsList`}
 data="selected.location_id"
 location_id={selectedLocationIdValueData}
/>
</div>
{children}
</React.Fragment>)
}